import { render, staticRenderFns } from "./TagSpendAreaChart.vue?vue&type=template&id=8e6cff7a&"
import script from "./TagSpendAreaChart.vue?vue&type=script&lang=ts&"
export * from "./TagSpendAreaChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports